import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { LuPencil } from "react-icons/lu";
import requestApi from "../../apirest/index";
import { showErrorWithToast } from "../../utils/showErroUtil";
import { ToastContainer, toast } from "react-toastify";
import _ from "lodash";
import Loading from "../../shared/components/Loading/Loading";
import Production from './Production';
import TotalCost from "./TotalCost";
import Logistics from "./Logistics";
import Prototype from "./Prototype";
import formatBRL from "../../shared/utils/formatBRL";
import categoryLabel from "../../shared/utils/categoryLabel";
import "./Costs.css";

const PAGE_SIZE = 10;

const Costs = () => {

  const [view, setView] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  const [costsByProduct, setCostsByProduct] = useState({});
  const [product, setProduct] = useState(0);
  const [productsList, setProductsList] = useState([]);
  const [productsFiltered, setProductsFiltered] = useState([]);
  const [productionData, setProductionData] = useState({
    textiles: [],
    notions: [],
    totalAmountTextiles: 0,
    totalAmountNotions: 0,
    patternDesignCost: 0,
    totalAmount: 0,
  });

  const [prototypeData, setPrototypeData] = useState({
    textiles: [],
    notions: [],
    totalAmountTextiles: 0,
    totalAmountNotions: 0,
    productionCost: 0,
    totalAmount: 0,
  });
  const [logisticsData, setLogisticsData] = useState({
    logistica: [],
    totalAmount: 0,
  });

  const [totalCostData, setTotalCostData] = useState({
    amountPrototype: 0,
    producedQuantity: 1,
    price: 0,
    totalScalingCost: 0
  });

  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");

  useEffect(() => {
    (async () => {
      setLoading(true);
      const [products, productionDocs, totalCostDocs] = await Promise.all([
        findProductList(),
        requestApi(`/production`, {}, "get").then((res) => res.data.doc).catch(() => []),
        requestApi(`/totalCost`, {}, "get").then((res) => res.data.doc).catch(() => []),
      ]);
      setProductsList(products || []);
      setProductsFiltered(products || []);

      const index = {};
      (productionDocs || []).forEach((doc) => {
        const productId = doc?.product?._id;
        if (productId) index[productId] = { ...index[productId], custoProducao: doc.totalAmount };
      });
      (totalCostDocs || []).forEach((doc) => {
        const productId = doc?.product;
        if (productId) {
          index[productId] = {
            ...index[productId],
            custoPiloto: doc.amountPrototype,
            custoTotal: doc.price,
          };
        }
      });
      setCostsByProduct(index);
      setLoading(false);
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab); // Atualizar a aba ativa
    }
  };

  // Função que será chamada pelo componente Production
  const handleProductionChange = (newDataProduction) => {
    console.log(newDataProduction);
    setProductionData(newDataProduction); // Atualiza os dados do estado no pai
  };

  const handlePrototypeChange = (newDataPrototype) => {
    setPrototypeData(newDataPrototype); // Atualiza os dados do estado no pai
  };

  const handleLogisticsChange = (newDataLogistics) => {
    setLogisticsData(newDataLogistics); // Atualiza os dados do estado no pai
  };

  const handleTotalCostChange = (newDataTotalCost) => {
    setTotalCostData(newDataTotalCost); // Atualiza os dados do estado no pai
  };

  const saveModel = async (model, data, setData) => {
    const method = data.id ? "patch" : "post";
    try {
      const response = await requestApi(`/${model}`, { [model]: data }, method);

      if (response?.status === 201 && response?.data?._id) {
        setData(prevData => ({ ...prevData, id: response.data._id }));
      }
    } catch (error) {
      console.error(`Erro ao salvar ${model}:`, error);
      toast.error(`Erro ao salvar ${model}:` + error, { autoClose: 4000 });
      throw error;
    }
  };


  const save = async () => {
    setLoading(true);
    try {
      await saveModel("prototype", prototypeData, setPrototypeData);
      await saveModel("production", productionData, setProductionData);
      await saveModel("logisticsCosts", logisticsData, setLogisticsData);
      await saveModel("totalCost", totalCostData, setTotalCostData);
      toast.success("Todas as informações foram salvas com sucesso.", { autoClose: 4000 });
    } catch (error) {
      console.error(error);
      toast.error("Aconteceu algum erro inesperado.", { autoClose: 4000 });
    } finally {
      setLoading(false);
    }
  };

  const findProductList = async () => {

    setLoading(true);

    try {
      let resp = await requestApi(`/products`, {}, "get");
      setLoading(false);
      return resp.data.doc;
    } catch (error) {
      console.log(error);
      toast.error("Aconteceu algum erro inesperado.", {
        autoClose: 4000,
      });

      setLoading(false);
    }
  };

  const findProductsByTerm = (searchTerm) => {
    setCurrentPage(1);

    if (!searchTerm) {
      setProductsFiltered(productsList);
      return;
    }

    const filtered = _.filter(productsList, function (product) {
      return (
        product.code.toUpperCase().includes(searchTerm.toString().toUpperCase()) ||
        product.name.toUpperCase().includes(searchTerm.toString().toUpperCase())
      );
    });
    setProductsFiltered(filtered);
  };

  const openProduct = (p) => {
    setProduct(p);
    setActiveTab("1");
    setView("form");
  };

  const backToList = () => {
    setView("list");
    setProduct(0);
  };

  const totalPages = Math.max(1, Math.ceil(productsFiltered.length / PAGE_SIZE));
  const pagedProducts = useMemo(
    () => productsFiltered.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE),
    [productsFiltered, currentPage]
  );

  const renderProductListView = () => {
    return (
      <div className="cp-page">
        <ToastContainer />
        <div className="cp-topbar">
          <div>
            <p className="cp-topbar-breadcrumb">Produtos</p>
            <h1 className="cp-topbar-title">Produtos</h1>
          </div>
          <div className="cp-topbar-actions">
            <Link to="/admin-panel/product-create" className="cp-btn cp-btn--primary">
              + Novo produto
            </Link>
          </div>
        </div>

        <div className="cp-field cost-search-field">
          <input
            type="text"
            className="cp-input"
            placeholder="Buscar produto por nome ou código..."
            onChange={(e) => findProductsByTerm(e.target.value)}
          />
        </div>

        <div className="cp-card cost-table-card">
          {pagedProducts.length > 0 ? (
            <div className="cost-table-scroll">
              <table className="cost-table">
                <thead>
                  <tr>
                    <th>Código</th>
                    <th>Produto</th>
                    <th>Custo de Produção</th>
                    <th>Custo de Piloto</th>
                    <th>Custo Total</th>
                    <th>Markup 10%</th>
                    <th>Markup 30%</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {pagedProducts.map((p) => {
                    const costs = costsByProduct[p._id] || {};
                    const custoTotal = costs.custoTotal;
                    return (
                      <tr key={p._id}>
                        <td>{p.code}</td>
                        <td>
                          <div className="cost-table-product">
                            <img
                              src={p?.variants?.[0]?.pictures?.[0]?.url}
                              className="cost-table-product-img"
                              alt={p.name}
                            />
                            <div>
                              <p className="cost-table-product-name">{p.name}</p>
                              <p className="cost-table-product-category">{categoryLabel(p.category)}</p>
                            </div>
                          </div>
                        </td>
                        <td>{formatBRL(costs.custoProducao)}</td>
                        <td>{formatBRL(costs.custoPiloto)}</td>
                        <td>{formatBRL(custoTotal)}</td>
                        <td>{typeof custoTotal === "number" ? formatBRL(custoTotal * 1.1) : "—"}</td>
                        <td>{typeof custoTotal === "number" ? formatBRL(custoTotal * 1.3) : "—"}</td>
                        <td>
                          <button
                            type="button"
                            className="cp-btn cp-btn--secondary cost-table-edit-btn"
                            onClick={() => openProduct(p)}
                          >
                            <LuPencil /> Editar
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            !loading && <p className="cost-product-empty">Nenhum produto encontrado.</p>
          )}
        </div>

        {totalPages > 1 && (
          <div className="cost-pagination">
            <button
              type="button"
              className="cp-btn cp-btn--secondary"
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
            >
              ‹
            </button>
            {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
              <button
                key={page}
                type="button"
                className={`cost-pagination-page${page === currentPage ? " cost-pagination-page--active" : ""}`}
                onClick={() => setCurrentPage(page)}
              >
                {page}
              </button>
            ))}
            <button
              type="button"
              className="cp-btn cp-btn--secondary"
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
            >
              ›
            </button>
          </div>
        )}

        {loading && <Loading overlay />}
      </div>
    );
  };

  const renderProduct = () => {
    return <div className="cp-page cost-product-page">
      <Prototype onPrototypeChange={handlePrototypeChange} productFinded={product} savedId={prototypeData.id} />

      {
        loading && <Loading overlay />
      }
    </div >;
  }

  const tabs = [
    { id: "1", label: "Piloto" },
    { id: "2", label: "Produção" },
    { id: "3", label: "Logística" },
    { id: "4", label: "Resumo" },
  ];

  const componentTabs = () => {
    return (
      <div className="cp-page">
        <ToastContainer />

        <div className="cp-topbar">
          <button type="button" className="cp-btn cp-btn--secondary" onClick={backToList}>
            ‹ Voltar
          </button>
          <div className="cp-topbar-actions">
            <button type="button" className="cp-btn cp-btn--primary" disabled={loading} onClick={() => save()}>
              Salvar
            </button>
          </div>
        </div>

        <div className="cp-card cost-product-header">
          <img
            src={product?.variants?.[0]?.pictures?.[0]?.url}
            className="cost-product-header-img"
            alt={product?.name}
          />
          <div>
            <p className="cp-topbar-breadcrumb">{product?.code}</p>
            <h1 className="cost-product-header-name">
              {prototypeData?.product?.name || product?.name || "Produto - Selecionar"}
            </h1>
            <p className="cost-product-header-category">{categoryLabel(product?.category)}</p>
          </div>
        </div>

        <div className="cost-tabs-nav">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`cost-tab-btn${activeTab === tab.id ? " cost-tab-btn--active" : ""}`}
              disabled={tab.id !== "1" && !product?._id}
              onClick={() => toggle(tab.id)}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {activeTab === "1" && renderProduct()}
        {activeTab === "2" && (
          <Production onProductionChange={handleProductionChange} productFinded={product} savedId={productionData.id} />
        )}
        {activeTab === "3" && (
          <Logistics onLogisticsChange={handleLogisticsChange} productFinded={product} savedId={logisticsData.id} />
        )}
        {activeTab === "4" && (
          <TotalCost
            onTotalCostChange={handleTotalCostChange}
            totalAmountPrototype={prototypeData.totalAmount}
            totalProduced={productionData.totalAmount}
            totalLogistics={logisticsData.totalAmount}
            productFinded={product}
            savedId={totalCostData.id}
          />
        )}
      </div>
    )
  }

  return (
    <>
      {view === "list" ? renderProductListView() : componentTabs()}
    </>
  );


};

export default Costs;




